<template>
<div id="app">
<v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Invoice-Status-Query')}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>
   <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select :label="$t('Type')" items-value="value" item-text="text" :items="itemstip"
                          v-model="radioGroup"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="tarih1" v-model="tarih1"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="tarih2" v-model="tarih2"></tarihcomp>
                      </v-flex>
                      <!-- <v-flex xs12 pt-2 sm5 md3>
                                    <v-text-field
                                        label="Fatura No"
                                        v-model="FaturaNoSearch"
                                    >
                                       
                                    </v-text-field>
                                </v-flex> -->

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="!progress">
                            <v-btn color="info" @click="Sorgula()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <!-- <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>Arama Filtresi Ekle</span>
                            </v-tooltip>
                          </v-badge> -->
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm0 md1>
                                </v-flex>
 
                                <v-flex xs12 sm5 md3>
                                    <v-text-field
                                        label="Fatura Seri"
                                        v-model="SearchFaturaSeri"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 sm5 md3>
                                    <v-text-field
                                        label="Fatura No"
                                        v-model="SearchRecieptNumber"
                                    >
                                        <template v-slot:append-outer>
                                            <v-icon color="info" @click="searchInvoice()" >send</v-icon>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items="[20,100]" :items="desserts"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">{{ props.item.FaturaIcerik.Fatura.tarih | dateformat }}</td>
                                    <!-- <td class="text-xs-left">{{ props.item.FaturaIcerik.Fatura.seri }}</td>-->

                                    <td class="text-xs-left">{{ props.item.FaturaIcerik.Fatura.seriYilNo }}</td>
                                    <td class="text-xs-left">{{ props.item.FaturaIcerik.HesapKodu }}</td>
                                    <td class="text-xs-left">{{ props.item.FaturaIcerik.GuId }}</td>
                                    <td class="text-xs-left">{{ props.item.InvoiceStatus }}</td>
                                    <td class="text-xs-left">{{ props.item.InvoiceResponseNote }}</td>
                                  </tr>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                  {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

</div>

</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "../coper/tools";
  import tarihcomp from "../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";


export default {
  components: {
    basepage,
    tarihcomp
  },
  data() {
    return {
      sovos:false,
      SearchRecieptNumber:'',
      SearchFaturaSeri:'',
      
      status: tool.NewSatatus(),
      tarih1: null,
      tarih2: null,
      radioGroup: 1,
      desserts: [],

        itemstip: [{
          text: this.$t('E-Invoice'),
          value: 1
        },
        {
          text: 'E-Arşiv',
          value: 2
        }

        ],

        itemskomisyon: [{
          text: this.$t('None'),
          value: false
        }, {
          text: this.$t('Available'),
          value: true
        }, {
          text: this.$t('All-v2'),
          value: null
        }],
        tarihTip: 0,

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
        filtrevarmi: false,
        search: "",
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,



        headerssatis: [{
            text: this.$t('Date'),
            value: "FaturaIcerik.Fatura.tarih",
            width: "5%",
            align: "left"
          },
          {
            text: "Seri Yıl No",
            value: "FaturaIcerik.Fatura.seriYilNo",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Accound-Code'),
            value: "FaturaIcerik.HesapKodu",
            width: "10%",
            align: "left"
          },
          {
            text: "Guid",
            value: "FaturaIcerik.GuId",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Status'),
            value: "InvoiceStatus",
            width: "10%",
            align: "left"
          },
          {
            text: "Fatura Not",
            value: "InvoiceResponseNote",
            width: "10%",
            align: "left"
          }
        ],


               valid: true,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: "",
        date2: null,
        menu2: false,
        dateFormatted2: "",
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",


        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        yok: false,


        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",


    };
  },
  mounted() {
    try {
      this.sovos = JSON.parse(window.localStorage.getItem('sovos'));
    }
    catch {
      console.log('sovos okunamadı');
    }

    if (this.sovos === true) {
      this.itemstip.push({
        text: 'Sadece Credit Note',
        value: 3
      });
       this.itemstip.push({
        text: 'Sadece Debit Note',
        value: 4
      });
    }
  },
  methods: {
searchInvoice(){
 this.progress=true
      var prm = {
        tip: this.radioGroup,
        tarih1: this.tarih1,
        tarih2: this.tarih2,
        FaturaNo:this.SearchRecieptNumber,
        FaturaSeri:this.SearchFaturaSeri
      };
      this.status.loading = true;
      this.desserts = [];

      tool.api_post(this, "EFatura/EFaturaDurumSorgula", prm).then(
        response => {
            this.progress=false
          this.desserts = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
              this.progress=false
        }
      );
},
    Sorgula() {
      this.progress=true
      var prm = {
        tip: this.radioGroup,
        tarih1: this.tarih1,
        tarih2: this.tarih2,
        // FaturaNo:this.FaturaNoSearch
      };
      this.status.loading = true;
      this.desserts = [];

      tool.api_post(this, "EFatura/EFaturaDurumSorgula", prm).then(
        response => {
            this.progress=false
          this.desserts = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
              this.progress=false
        }
      );

    }
  },
   filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
};
</script>
